import React from 'react';
import './TeacherInstruction.css';
import foldTeacher from '../../Assets/foldTeacher.png'

function TeacherInstruction() {
  return (
    <div className='teacherInstruction-container'>
        <span className='teacherInstruction-title'>How to begin</span>
        <div className='teacherInstruction-split'>
        <div className='teacherInstructions'>
            <span className='teacherInstructions-subtitle'>Plan your class</span>
            <p>You start with your passion and knowledge. Then choose a promising topic with the help of our Marketplace Insights tool.
            The way that you teach — what you bring to it — is up to you.</p>

            <span className='teacherInstructions-subtitle'>Record your Video</span>
            <p>Use basic tools like a smartphone or a DSLR camera. Add a good microphone and you’re ready to start.
            If you don’t like being on camera, just capture your screen. Either way, we recommend two hours or more of video for a paid course.</p>

            <span className='teacherInstructions-subtitle'>Launch your class</span>
            <p>Gather your first ratings and reviews by promoting your course through social media and your professional networks.
            Your course will be discoverable in our marketplace where you earn revenue from each paid enrollment.</p>
        </div>
        <img src={foldTeacher} alt="foldTeacher" className='fold-teacher'/>
        </div>
    </div>
  )
}

export default TeacherInstruction